import { render, staticRenderFns } from "./CheckboxEditor.vue?vue&type=template&id=c7939940&scoped=true&"
import script from "./CheckboxEditor.vue?vue&type=script&lang=js&"
export * from "./CheckboxEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7939940",
  null
  
)

export default component.exports